import { render, staticRenderFns } from "./CmgUpdatePasswordConfirmModal.vue?vue&type=template&id=d6071818&scoped=true&lang=pug"
import script from "./cmg-update-password-confirm-modal.ts?vue&type=script&lang=ts&external"
export * from "./cmg-update-password-confirm-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgUpdatePasswordConfirmModal.vue?vue&type=style&index=0&id=d6071818&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6071818",
  null
  
)

export default component.exports